import React, { useEffect, useState } from "react";
import classNames from "classnames";
import copyButtonStyles from "./CopyButton.module.scss";
import { CopyIcon, DownloadIcon } from "@netapp/bxp-design-system-react/icons/monochrome";
import { CSSTransition } from "react-transition-group";
import ReactDOM from "react-dom";
import { CopyToClipboard } from "react-copy-to-clipboard";
import _ from "lodash";
import FormFieldInputNew from "../Forms/FormFieldInputNew"
import FormFieldInputButton from "../Forms/FormFieldInputButton"
import { saveToDisk } from "./../../"
import { TooltipContent } from "./Tooltip";

export const FormFieldDownloadButton = ({ contents, fileName, onDownload, includeLabel }) => {
    const onClick = onDownload ? onDownload : () => saveToDisk({ contents, fileName });

    return <FormFieldInputButton Icon={DownloadIcon} onClick={onClick} label={includeLabel ? "Download" : undefined}/>
}

export const FormFieldCopyButton = ({ text: _text, includeLabel }) => {
    const [showBubble, setShowBubble] = useState(false);
    const [bubblePosition, setBubblePosition] = useState({});
    const buttonRef = React.createRef();
    const bubbleRef = React.createRef();
    const text = _.isObject(_text) ? JSON.stringify(_text, null, 4) : _text;

    useEffect(() => {
        if (showBubble && buttonRef.current) {
            const { top, left, width } = buttonRef.current.getBoundingClientRect();
            const maxWidth = document.body.clientWidth;
            let isLeft = false;
            if (left + width + 60 > maxWidth) {
                isLeft = true;
            }

            setBubblePosition({ top: top - 31, left: left + (isLeft ? 0 : width), isLeft })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [showBubble]);

    return <CopyToClipboard text={text} onCopy={() => {
        setShowBubble(true);
        setTimeout(() => {
            setShowBubble(false);
        })
    }}>
        <FormFieldInputButton Icon={CopyIcon} ref={buttonRef} label={includeLabel ? "Copy" : undefined}>
            <CSSTransition nodeRef={bubbleRef} in={showBubble} unmountOnExit timeout={1000}>
                    <span ref={bubbleRef} style={{ position: "absolute" }}>
                        {ReactDOM.createPortal(<div className={classNames(copyButtonStyles['bubble'], { [copyButtonStyles['left']]: bubblePosition.isLeft })} style={{ top: bubblePosition.top, left: bubblePosition.left }}>
                            <TooltipContent>Copied!</TooltipContent></div>, document.body)}
                    </span>
            </CSSTransition>
        </FormFieldInputButton>
    </CopyToClipboard>
};

export default ({ text, download, onDownload, includeLabel, ...rest }) => {
    return (
        <FormFieldInputNew {...rest} value={text} inputButtons={
            <>
                <FormFieldCopyButton includeLabel={includeLabel} text={text}/>
                {(download || onDownload) && <FormFieldDownloadButton includeLabel={includeLabel} onDownload={onDownload} contents={download.contents} fileName={download.fileName}/>}
            </>
        }/>
    )
};
